import { render, staticRenderFns } from "./Article3Content.vue?vue&type=template&id=8594eeaa&scoped=true"
var script = {}
import style0 from "./Article3Content.vue?vue&type=style&index=0&id=8594eeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8594eeaa",
  null
  
)

export default component.exports